const lang = {
  add_title: '<b>{userName}</b>さんが<br> <b>「{constructionName}」</b><br>に招待しています。',
  add_content: '下記からZENGOに登録して<br> この案件の共同作業に参加しましょう。',
  empty_name: '案件名未入力'
}

export default lang;



// WEBPACK FOOTER //
// ./src/lang/ja/pages/inviteNewUserInput.js